import { UseCase } from '@/apis/core';
import regexExpressions from '@/constants/regexExpressions';
import { UsecaseType } from '@/utils/types';

export const isRequired = (value?: string | string[]) =>
  !!value?.length || 'Required';
export const isValidEmail = (value?: string) =>
  regexExpressions.email.test(value?.trim() || '') || 'Invalid email';
export const useCaseRequired = (value?: UsecaseType) =>
  !!value?.id || 'Please select a campaign use-case';
export const rcsUseCaseRequired = (value?: UseCase) =>
  !!value?.id || 'Required';

export const createSubUseCasesCountValidator =
  (minCount: number, maxCount: number) => (value?: string[]) =>
    maxCount <= 0 ||
    (value?.length ?? 0) >= minCount ||
    `At least ${minCount} sub use-case${
      minCount > 1 ? 's' : ''
    } to be selected`;
